import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Popover } from 'react-tiny-popover';
import dayjs from 'dayjs';
import { MoreHorizontal } from 'react-feather';
import styles from 'styles/Calendar.module.scss';
import classnames from 'classnames';
import {
  USER_EVENT_TYPE,
  UNIT_TYPE,
  USER_METHODS,
} from '../../constants/constants';

const PopoverCalendar = ({
  content,
  info,
  isOpen,
  onClickEvent,
  courseCalPopup,
}) => {
  const eventId = info?.event?._def?.extendedProps?._id;
  const title = info?.event?._def?.title;
  const typeView = info?.view?.type;
  const begin = info?.event?._def?.extendedProps?.time?.begin;
  let type = info?.event?._def?.extendedProps?.type;
  const timeText = dayjs(begin).format('HH:mm');
  if (type === 'WEBINAR') {
    type = 'Live Training';
  } else if (type === 'CLASSROOM') {
    type = 'Classroom Training';
  }

  return (
    <Popover
      isOpen={isOpen}
      content={content}
      containerStyle={{
        zIndex: 1000,
      }}
      positions={'top'}
      containerClassName={`${
        courseCalPopup
          ? 'leaner-calendar-res classroomCalendarPopup'
          : 'leaner-calendar-res'
      } `}
    >
      <div
        onClick={() => onClickEvent(eventId)}
        className={classnames(
          typeView === 'dayGridMonth' &&
            'd-flex align-items-center overflow-hidden',
        )}
      >
        {USER_EVENT_TYPE.EVENT === 'EVENT' ? (
          <div>
            <div id="event" className={classnames(styles['dots-color'])}>
              <div className="fc-event-type mb-0">{type} </div>
              <div className="fc-event-title mb-0">{title} </div>
              {/* <div className="fc-event-time whiteSpaceNowrap"> {timeText}</div> */}
            </div>
          </div>
        ) : USER_EVENT_TYPE.CLASSROOM === 'CLASSROOM' ? (
          <div className={classnames(styles['dots-color'])}>
            <div className="fc-event-type mb-0">{type} </div>
            <div className="fc-event-title mb-0">{title} </div>
            {/* <div className="fc-event-time whiteSpaceNowrap"> {timeText}</div> */}
          </div>
        ) : USER_EVENT_TYPE.WEBINAR === 'WEBINAR' ? (
          <div className={classnames(styles['dots-color'])}>
            <div className="fc-event-type mb-0">{type} </div>
            <div className="fc-event-title mb-0">{title} </div>
            {/* <div className="fc-event-time whiteSpaceNowrap"> {timeText}</div> */}
          </div>
        ) : (
          ''
        )}
      </div>
    </Popover>
  );
};

PopoverCalendar.propTypes = {
  content: PropTypes.any,
  info: PropTypes.object.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClickEvent: PropTypes.func.isRequired,
};

export default PopoverCalendar;
